import React from 'react';
import { Ic } from './Icons';
import { ACCENT } from '../lib/tokens';

export default function HamburgerMenu({ open, onClose, onNavigate, isPostEvent }) {
  const items = [
    { id: 'logistics', label: 'Logistics', icon: <Ic.Map size={18} color={ACCENT} /> },
    { id: 'commitments', label: 'Commitments', icon: <Ic.Check size={18} color={ACCENT} /> },
    { id: 'resources', label: 'Resources', icon: <Ic.Link size={18} color={ACCENT} /> },
    { id: 'uploads', label: 'Uploads & Links', icon: <Ic.Upload size={18} color={ACCENT} /> },
    {
      id: 'post-event',
      label: 'Post-Event',
      icon: <Ic.Shield size={18} color={isPostEvent ? ACCENT : '#cbd5e1'} />,
    },
  ];

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(10,15,30,0.6)',
          zIndex: 30,
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'opacity 0.2s',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: '78%',
          maxWidth: 300,
          background: '#162038',
          zIndex: 35,
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.28s cubic-bezier(0.32,0.72,0,1)',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '-8px 0 40px rgba(0,0,0,0.35)',
        }}
      >
        <div
          style={{
            padding: '52px 22px 18px',
            borderBottom: '1px solid rgba(255,255,255,0.07)',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              marginBottom: 14,
            }}
          >
            <img src="/elx-logo-white.png" alt="ELX" style={{ height: 26, objectFit: 'contain' }} />
            <button
              onClick={onClose}
              aria-label="Close menu"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}
            >
              <Ic.Close size={20} color="rgba(255,255,255,0.6)" />
            </button>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '8px 10px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: 9,
              border: '1px solid rgba(255,255,255,0.07)',
            }}
          >
            <img
              src="/chirocongress-logo-white.png"
              alt="ChiroCongress"
              style={{ height: 20, objectFit: 'contain', opacity: 0.75 }}
            />
            <span
              style={{
                fontSize: 11,
                color: 'rgba(255,255,255,0.45)',
                fontWeight: 500,
                letterSpacing: '0.02em',
              }}
            >
              A ChiroCongress Event
            </span>
          </div>
        </div>

        <div
          style={{
            flex: 1,
            padding: '12px 10px',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          {items.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                onNavigate(item.id);
                onClose();
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 13,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '12px 14px',
                borderRadius: 11,
                textAlign: 'left',
                color: 'rgba(255,255,255,0.75)',
              }}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 9,
                  background: 'rgba(255,255,255,0.06)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </div>
              <span style={{ fontSize: 15, fontWeight: 500 }}>{item.label}</span>
              <Ic.ChevronRight
                size={14}
                color="rgba(255,255,255,0.25)"
                style={{ marginLeft: 'auto' }}
              />
            </button>
          ))}
        </div>

        <div
          style={{
            padding: '10px 20px 32px',
            borderTop: '1px solid rgba(255,255,255,0.06)',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <a
            href="/anatomy"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            style={{
              fontSize: 12.5,
              color: 'rgba(255,255,255,0.5)',
              textDecoration: 'none',
              padding: '4px 0',
              letterSpacing: '0.02em',
              textAlign: 'left',
            }}
          >
            For the curious →
          </a>
          <button
            onClick={() => {
              onNavigate('admin');
              onClose();
            }}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 12,
              color: 'rgba(255,255,255,0.18)',
              padding: '4px 0',
              letterSpacing: '0.04em',
              textAlign: 'left',
            }}
          >
            ··· admin access
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, opacity: 0.4 }}>
            <span
              style={{
                fontSize: 10.5,
                color: 'rgba(255,255,255,0.6)',
                letterSpacing: '0.04em',
              }}
            >
              Hosted by
            </span>
            <img
              src="/chirocongress-logo-white.png"
              alt="ChiroCongress"
              style={{ height: 16, objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
